<template>
    <div ref="chartDom22" id="auxiliaryEchart"></div>
</template>

<script>
import * as echarts from 'echarts';
import resize from "@/mixins/chartResize";

export default {
    mixins: [resize],
    data(){
        return{
            chart: null,
            option: {}
        }
    },
    created(){
        setTimeout(() => {
            this.init()
        }, 800);
    },
    methods: {
        init(){
            var datas = [
                ////////////////////////////////////////
                [
                    { name: '圣彼得', value: 1 },
                    { name: '陀思妥', value: 0 },
                    { name: '史记精', value: 0 },
                    { name: '加德纳', value: 0 },
                    { name: '表象与本', value: 0.5 },
                    { name: '其它', value: 3 }
                ],
            ];
            this.chart = echarts.init(this.$refs.chartDom22);

            this.option = {
                title: {
                    text: '阅读书籍分布',
                    left: 'center',
                    textStyle: {
                        color: '#999',
                        fontWeight: 'normal',
                        fontSize: 14
                    }
                },
                series: datas.map(function (data, idx) {
                    // var top = idx * 33.3;
                    return {
                    type: 'pie',
                    radius: [20, 60],
                    top: '100',
                    height: '33.33%',
                    left: 'center',
                    width: 400,
                    itemStyle: {
                        borderColor: '#fff',
                        borderWidth: 1
                    },
                    label: {
                        alignTo: 'edge',
                        // formatter: '{name|{b}}\n{time|{c} 小时}',
                        minMargin: 5,
                        edgeDistance: 10,
                        lineHeight: 15,
                        rich: {
                            time: {
                                fontSize: 10,
                                color: '#999'
                            }
                        }
                    },
                    labelLine: {
                        length: 15,
                        length2: 0,
                        maxSurfaceAngle: 80
                    },
                    labelLayout: function (params) {
                        console.log('params----', params)
                        // const isLeft = params.labelRect.x < this.chart.getWidth() / 2;
                        const isLeft = 0.2;
                        const points = params.labelLinePoints;
                        // Update the end point.
                        points[2][0] = isLeft
                        ? params.labelRect.x
                        : params.labelRect.x + params.labelRect.width;
                        return {
                            labelLinePoints: points
                        };
                    },
                    data: data
                    };
                })
            };
            this.chart.setOption(this.option);
        }
    }
}
</script>

<style lang="scss" scoped>
#auxiliaryEchart {
  width: 80%;
  height: 80%;
//   background-color: white;
}

</style>